import React, { useState, useMemo } from "react";
import { CreateOutflow } from "../../pages";
import { WalletController } from "../../controllers";
import { walletStore } from "../../stores";

const CreateOutflowContainer = () => {
  const [loading, setLoading] = useState(false);
  const [createOutflowModal, setCreateOutflowModal] = useState(false);
  const [reviewOutflowModal, setReviewOutflowModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const outflowTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = WalletController.useGetOutflow(
    outflowTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreateOutflow = () => {
    setCreateOutflowModal(true);
  };

  const goToReviewOutflow = (item) => {
    walletStore.setOutflowData(item);
    setReviewOutflowModal(true);
  };

  const closeModal = () => {
    setCreateOutflowModal(false);
    setReviewOutflowModal(false);
  };

  return (
    <CreateOutflow
      goToCreateOutflow={goToCreateOutflow}
      loading={loading}
      closeModal={closeModal}
      createOutflowModal={createOutflowModal}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      onLimitChange={onLimitChange}
      limit={limit}
      setSearchQuery={setSearchQuery}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      goToReviewOutflow={goToReviewOutflow}
      reviewOutflowModal={reviewOutflowModal}
    />
  );
};
export default CreateOutflowContainer;
